import * as React from 'react';

import { getTranslation } from '@utils';

import { Feedback } from '@common/components/Feedback';
import { MultilineText } from '@common/components/MultilineText';
import { AppStat } from '@common/utils/AppStat';

import { Icon } from '@components/Icon';

import { IconCheck } from '@icons';

import * as s from './DmcaSuccess.scss';

const t = getTranslation('common.containers.Dmca.components.DmcaSuccess');

const DmcaSuccessComponent = () => {
	AppStat.log.boom.showSuccessForBoomDmca();

	return (
		<div className={s.block}>
			<div className={s.iconContainer}>
				<Icon glyph={IconCheck} className={s.icon}/>
			</div>

			<div className={s.title}>
				{t('title')}
			</div>

			<div className={s.prompt}>
				<MultilineText text={t('prompt')}/>
				{' '}
				<Feedback
					title={t('support')}
					classNames={{
						block: s.feedbackBlock,
						link: s.feedbackLink,
					}}
				/>
				{'.'}
			</div>
		</div>
	);
};

export const DmcaSuccess = React.memo(DmcaSuccessComponent, () => true);
